import React, { useState, useEffect } from 'react'
import SearchPanel from '../../components/SearchPanel'
import GridPanel from '../../components/GridPanel'
import PropTypes from "prop-types";
import { isMobileOnly } from 'mobile-device-detect';
import { useDroppable } from '@dnd-kit/core';
import './style.less';
import { Accordion } from 'semantic-ui-react';
//import { DualAxes } from '@ant-design/charts';

const GridSearchTemplate = ({ options, onGridUpdate, onSearchComplete, onSearchChange, data, onSelected }) => {
  const [_data, setData] = useState([])
  const { setNodeRef: refSearchPanel, isOver: isOverSearchPanel } = useDroppable({ id: "search-panel" });
  const { setNodeRef: refGridPanel, isOver: isOverGridPanel } = useDroppable({ id: "grid-panel" });

  // Data passed from parent component overrides internal data
  useEffect(() => {
    setData(data || []);
  }, [data])

  const searchComplete = (data, state) => {
    if (onSearchComplete) {
      var result = onSearchComplete(data, state)
      if (result instanceof Promise) {
        result.then(retval => {
          if (retval) {
            setData(data)
          }
        });
      } else if (result) {
        setData(data)
      }
    } else {
      setData(data)
    }
  }

  return (
    <div className={`grid-search-template ${isMobileOnly ? "mobile" : ""}`} style={{ flexDirection: "column", flex: 1, display: "flex", width: "100%", height: "100%", overflow: isMobileOnly ? "auto" : "hidden" }}>
      <div ref={refSearchPanel} className={`search-panel ${isOverSearchPanel ? "drag-over" : ""}`}>
        <SearchPanel options={options.search} onSetState={onSearchChange} onSearchComplete={searchComplete} />
      </div>
      {options.chart && <div>
        <Accordion panels={[
          {
            key: "chart",
            title: "Chart",
            content: {
              content: options.chart(_data)
            }
          }
        ]} />
      </div>}
      <div ref={refGridPanel} className={`grid-panel ${isOverGridPanel ? "drag-over" : ""}`} style={{ flex: 1, display: "flex", 'overflowX': options.grid.scrollbarX ? isMobileOnly ? 'visble' : 'auto' : 'hidden' }}>
        <GridPanel options={{ ...options.grid, title: options.search.title }} data={_data} onUpdate={onGridUpdate} onSelected={onSelected} />
      </div>
    </div>
  )
}

GridSearchTemplate.propTypes = {
  options: PropTypes.object,
  onGridUpdate: PropTypes.func,
  onSearchComplete: PropTypes.func,
  data: PropTypes.any,
  onSelected: PropTypes.func,
  onSearchChange: PropTypes.func,
  selectionIndexes: PropTypes.array
}
export default React.memo(GridSearchTemplate)